var showDialog,
    showBigLoader,
    closeBigLoader;
(function($) {
	$(function() {
		var dialog = $('#dialog'),
		    closeDialog;
		if (dialog.length) {
			var dialogInner = dialog.find('.container'),
			    dialogPopup = dialog.find('.popup'),
			    dialogClose = dialog.find('.dialog-close'),
			    //dialogIcon = dialog.find('.iconed-block'),
			    dialogContentBlock = dialog.find('.popup-content');

			showDialog = function (dialogContent, iconClass, firedOnElem, showCallback, closeCallback) {

				if (bigLoader.length && bigLoader.is(':visible')) {
					closeBigLoader();
				}

				var dialogContentParent = dialogContent.parent();//to append dialogContent here after popup closing
				dialogContentBlock.append(dialogContent);

				if (dialogContent.hasClass('little-msg')) {//popup with half-width picture on the right side
					iconClass += ' little-msg';
				}

				if (dialogContent.hasClass('no-bckg')) {//popup with half-width picture on the right side
					iconClass += ' no-bckg';
				}

				if (dialogContent.hasClass('iconed-element')) {//LP PAMM callback form (for success)
					iconClass += ' iconed-element';
				}

				dialogPopup.addClass(iconClass);

				// dialog.show();
				//dialogIcon.addClass(iconClass);
				// checkHeight();
				// dialog.hide();
				dialog.fadeIn(transitionDuration, function() {
					
				});
				function checkHeight() {
					// console.log(dialogPopup.height(),dialogContentBlock.innerHeight())
					// if (dialogPopup.height() < dialogContentBlock.innerHeight()) {
					// 	dialogPopup.addClass('on-full-window');//to add scrool, when long content
					// } else {
					// 	dialogPopup.removeClass('on-full-window');
					// }
					var dialogHeight = dialog.height(),
						dialogInnerOuterHeight = dialogInner.outerHeight();
						
					if (dialogInnerOuterHeight < dialogHeight) {
						// dialogInner.css('margin-top', (dialogHeight - dialogInnerOuterHeight) / 2);
					} else {
						// dialogInner.css('margin-top', 'auto');
					}
				}
				// $window.on('custom.onresize', function() {
				// 	checkHeight();
				// });
				// if (dialogPopup.hasClass('height-may-change')) {
				// 	// setTimeout()
				// }
				$document.on('click.popup.closing', function(e) {
					var $etarget = $(e.target);
					
					if (
						(!$etarget.is(dialogPopup) &&
						!$etarget.is(dialogPopup.find('*')) && 
						!$etarget.is(firedOnElem)) &&
						!$etarget.is(firedOnElem.find('*')) ||
						$etarget.is(dialogClose)) {
						closeDialog();
					}

				});

				if (showCallback) {
					showCallback();
				}

				closeDialog = function() {
					dialog.fadeOut(transitionDuration, function() {
						dialogContentParent.append(dialogContent);
						//dialogIcon.removeClass(iconClass);
						dialogPopup.removeClass(iconClass + ' little-msg');
						$document.off('click.popup.closing');
						dialogPopup.trigger('popup.closed');//Used for example in LP PAMM callback form (to remove class success icon not to be always chekmark)
					});

					if (closeCallback) {
						closeCallback();
					}

				}
			}
		}
		var bigLoader = $('#big-loader');
		if (bigLoader.length) {
			showBigLoader = function() {
				if (dialog.length && dialog.is(':visible')) {
					closeDialog();
				}
				bigLoader.fadeIn(transitionDuration);
			}
			closeBigLoader = function() {
				bigLoader.fadeOut(transitionDuration);
			}
		}
	});
})(jQuery);